import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c7eacde&lang=html&"
import script from "./bindingPhone.js?vue&type=script&lang=js&"
export * from "./bindingPhone.js?vue&type=script&lang=js&"
import style0 from "./bindingPhone.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./resetVant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports